export default {
  computed: {
    isMobile() {
      return this.$mq === 'sm';
    },
  },
};
